import '@babel/polyfill'
import './styles/index.css'
import moment from 'moment'

import { startApp } from './javascripts/init';
import { startOxygen } from '../../shared/javascripts/oxygen/oxygen'

startApp();
startOxygen();